import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://masonry-pro.com";

/**
 * Automatically sets og:url and canonical link based on the current route.
 * Placed in RootLayout so every page gets correct values by default.
 * Individual pages can still override via their own <Helmet> blocks.
 */
export function PageMeta() {
  const { pathname } = useLocation();
  const currentUrl = `${BASE_URL}${pathname === "/" ? "" : pathname}`;

  return (
    <Helmet>
      <meta property="og:url" content={currentUrl} />
      <link rel="canonical" href={currentUrl} />
    </Helmet>
  );
}
